<template>
    <v-menu v-model="dialog" bottom rounded="0">
        <template v-slot:activator="{ on, attrs }">
            <v-btn text color="grey darken-1" class="rounded-0 justify-start pa-0" v-on="on" v-bind="attrs" width="100%">
                더보기
                <v-badge v-if="selected.length" :content="selected.length" inline color="primary" class="ml-2" />
            </v-btn>
        </template>
        <v-card class="pa-4 rounded-0">
            <v-chip-group v-model="selected" multiple color="primary" column>
                <v-chip v-for="child in children" :key="child.name" :value="child" filter outlined @click.stop="() => {}">
                    {{ child.name }}
                </v-chip>
            </v-chip-group>
        </v-card>
    </v-menu>
</template>

<script>
export default {
    props: {
        value: Array,
        children: Array,
    },
    computed: {
        value_children() {
            return this.value.filter(({ _parent, name }) => this.children.some((child) => child._parent == _parent && child.name == name));
        },
        value_others() {
            return this.value.filter(({ _parent, name }) => !this.children.some((child) => child._parent == _parent && child.name == name));
        },
        needsUpdate() {
            if (this.value_children.length !== this.selected.length) return true;
            else return this.value_children.some(({ _parent, name }) => !this.selected.some((child) => child._parent == _parent && child.name == name));
        },
    },
    data() {
        return {
            dialog: false,
            selected: [],
        };
    },
    methods: {
        init() {
            this.selected = this.value_children;
        },
        sync() {
            this.$emit("input", [...this.value_others, ...this.selected]);
        },
    },
    watch: {
        value_children() {},
        selected() {
            this.sync();
        },
    },
};
</script>

<style></style>
